<template>
  <div class="brand-filters-container-mobile">
    <FilterItemMobile
      :label="filterMeta.title"
      :selected-filter-label="selectedBrandNames"
      @click.native="
        $store.commit(
          'listingPageFilters/setListingPageCurrentFilterType',
          filterMeta
        )
      "
    />
    <Transition name="slide">
      <div
        v-if="currentFilterType.slugUrl === filterMeta.slugUrl"
        class="filter-value-list"
      >
        <TextField
          v-model="searchBrandModel"
          :field-name="$t('products.searchBrands')"
          icon="search"
          :placeholder="$t('products.searchBrands')"
        />
        <FilterItemMobile
          v-for="(brand, index) in filteredBrandList"
          :key="brand.id"
        >
          <template #filter-item-content>
            <Checkbox
              :id="brand.slugUrl"
              :key="brand.slugUrl"
              v-model="brandModel"
              :native-value="brand.slugUrl"
              position="right"
              :is-small="true"
              :is-stretched="true"
              @input="
                trackFilterEvent($event, {
                  value: brand.name,
                  slugUrl: brand.slugUrl,
                  filterIndex: index,
                  filterCategoryIndex: 0,
                  type: 'brand'
                })
              "
            >
              {{ brand.name }}
            </Checkbox>
          </template>
        </FilterItemMobile>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TextField from '@sephora-asia/inputs-text-field/TextField.vue'
import Checkbox from '@sephora-asia/inputs-checkbox/Checkbox.vue'
import filterTracking from '../mixins/filterTracking'
import productFiltersHelper from '../mixins/productFiltersHelper'
import FilterItemMobile from './FilterItemMobile.vue'

export default {
  name: 'BrandFiltersContainerMobile',

  components: {
    Checkbox,
    FilterItemMobile,
    TextField
  },

  mixins: [filterTracking, productFiltersHelper],

  computed: {
    ...mapGetters({
      currentFilterType: 'listingPageFilters/currentFilterType',
      brandFilters: 'listingPageFilters/brandFilters',
      filterParams: 'listingPageFilters/filterParams',
      searchBrand: 'listingPageFilters/searchBrand',
      showViewResultsCTAButton: 'listingPageFilters/showViewResultsCTAButton'
    }),

    brandModel: {
      get() {
        return this.filterParams.brands
      },

      set(value) {
        this.$store.commit(
          'listingPageFilters/setListingPageBrandFilterParams',
          value
        )

        // if View Results CTA Button is already displayed do nothing
        if (!this.showViewResultsCTAButton) {
          this.$store.commit(
            'listingPageFilters/setShowViewResultsCTAButton',
            true
          )
        }
      }
    },

    searchBrandModel: {
      get() {
        return this.searchBrand
      },

      set(value) {
        this.$store.commit(
          'listingPageFilters/setListingPageSearchBrand',
          value
        )
      }
    },

    filteredBrandList() {
      if (this.searchBrand) {
        // To search for accented brands name. For eg:- Chloé
        // Ref: https://github.com/shentao/vue-multiselect/issues/984
        return this.brandFilters.filter((brand) =>
          this.normalizeAccentedProductName(brand.name).includes(
            this.normalizeAccentedProductName(this.searchBrand).trim()
          )
        )
      }

      return this.brandFilters
    },

    filterMeta() {
      return {
        title: this.$t('products.brands'),
        slugUrl: 'brands',
        type: 'brand'
      }
    },

    selectedBrandNames() {
      if (!this.filterParams.brands.length) return ''

      const brandsNames = []

      for (const slugUrl of this.filterParams.brands) {
        const brand = this.brandFilters.find((br) => br.slugUrl === slugUrl)

        if (brand) {
          brandsNames.push(brand.name)
        }
      }

      return brandsNames.join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .form-checkbox-label {
    font-weight: 400;

    &.small {
      &:before,
      &:after {
        width: 18px;
        height: 18px;
      }
    }
  }

  .text-field {
    border-bottom: 1px solid $grey;

    input {
      border-bottom: 1px solid $grey;
      padding-left: 20px;
      font-size: 16px;
      height: 45px;
    }
  }

  .text-field-icon {
    --icon-size: 30px;
    --icon-fill-color: #{$black};
    --cursor-type: pointer;
    position: absolute;
    right: 14px;
    z-index: 0;
  }

  .filter-value-list {
    .nav-item-link {
      height: 46px;
      padding: 12px 20px 12px;
    }
  }
}
</style>
